class FaqDetails extends HTMLElement {
  constructor() {
    super();
    
    const details = this.querySelectorAll("details");

    details.forEach((targetDetail) => {
      targetDetail.addEventListener("click", () => {
        details.forEach((detail) => {
          if (detail !== targetDetail) {
            detail.removeAttribute("open");
          }
        });
      });
    });
  }

}

customElements.define('faq-details', FaqDetails);
